import { ShippingCarriers } from "../shippingCarriers";
import { ShippingService } from "../shippingRates.types";
import { getPricesWithoutVAT } from "../utils";

const GASOIL_FEE_COEFF = 1.275;

const addExtra = (price: number) => {
  return (
    (
      price
      + 0.64 // Customer address fee
    )
    * GASOIL_FEE_COEFF // Gasoil fee
    + 0.11 // Sendcloud label fee
  )
}

// PACK AND CARRY contract
export const sendcloud_packAndCarry_ups: ShippingService = {
  serviceCode: 'sendcloud_packAndCarry_ups',
  description: 'Buying on Sendcloud, through UPS Pack and Carry contract',
  deliveryType: 'home',
  carrier: ShippingCarriers.ups,

  externalMappings: {
    ebay: {
      carrierCode: 'UPS',
      serviceCode: 'FR_UPSStandard',
      serviceCodeInternational: 'FR_UPSStandardInternational',
    },
  },
  appliesVolumetricWeight: true,
  volumetricWeightDivider: 5000,
  maxDimensions: (size1: number, size2: number, size3: number, weight: number) => {
    if (weight >= 25000) {
      return { isValid: false, errorMessage: 'Max weight exceeded (25kg).' };
    }
    const sortedSizes = [size1, size2, size3].sort((a, b) => b - a);
    const calculation = sortedSizes[0] + 2 * (sortedSizes[1] + sortedSizes[2]);
    if (calculation > 300) {
      return { isValid: false, errorMessage: 'Max dimensions exceeded (300cm). Calculation is Length + 2 * (Width + Height)' };
    }
    return { isValid: true, errorMessage: '' };
  },

  ratesByDestination: [
    {
      destinations: ['FR'],
      rates: [
        {
          minWeight: 0,
          maxWeight: 2000,
          ...getPricesWithoutVAT(addExtra(4.61)),
        },
        {
          minWeight: 2000,
          maxWeight: 5000,
          ...getPricesWithoutVAT(addExtra(5.34)),
        },
        {
          minWeight: 5000,
          maxWeight: 10000,
          ...getPricesWithoutVAT(addExtra(5.93)),
        },
        {
          minWeight: 10000,
          maxWeight: 15000,
          ...getPricesWithoutVAT(addExtra(6.07)),
        },
        {
          minWeight: 15000,
          maxWeight: 20000,
          ...getPricesWithoutVAT(addExtra(6.66)),
        },
        {
          minWeight: 20000,
          maxWeight: 25000,
          ...getPricesWithoutVAT(addExtra(10.48)),
        },
        {
          minWeight: 25000,
          maxWeight: 30000,
          ...getPricesWithoutVAT(addExtra(13.56)),
        },
        {
          minWeight: 30000,
          maxWeight: 35000,
          ...getPricesWithoutVAT(addExtra(13.56)),
        }
      ]
    },
    {
      destinations: ['DE', 'AT', 'BE', 'LU', 'ES', 'IE', 'IT', 'NL', 'PT'],
      rates: [
        {
          minWeight: 0,
          maxWeight: 1000,
          ...getPricesWithoutVAT(addExtra(5.19)),
        },
        {
          minWeight: 1000,
          maxWeight: 2000,
          ...getPricesWithoutVAT(addExtra(5.34)),
        },
        {
          minWeight: 2000,
          maxWeight: 5000,
          ...getPricesWithoutVAT(addExtra(5.93)),
        },
        {
          minWeight: 5000,
          maxWeight: 10000,
          ...getPricesWithoutVAT(addExtra(6.37)),
        },
        {
          minWeight: 10000,
          maxWeight: 15000,
          ...getPricesWithoutVAT(addExtra(7.25)),
        },
        {
          minWeight: 15000,
          maxWeight: 20000,
          ...getPricesWithoutVAT(addExtra(7.98)),
        },
        {
          minWeight: 20000,
          maxWeight: 25000,
          ...getPricesWithoutVAT(addExtra(9.01)),
        },
        {
          minWeight: 25000,
          maxWeight: 30000,
          ...getPricesWithoutVAT(addExtra(10.63)),
        },
        {
          minWeight: 30000,
          maxWeight: 35000,
          ...getPricesWithoutVAT(addExtra(10.63)),
        }
      ]
    }
  ]
}